// src/components/ChatRequestsPanel.js
import React from 'react';
import { formatDistanceToNow } from 'date-fns';
// import { useChatRequests } from '@/contexts/ChatRequestContext';
import { CheckCircle, XCircle, Clock, User } from 'lucide-react';
import { useChatRequests } from '@/context/ChatRequestsContext';

export default function ChatRequestsPanel() {
    const { chatRequests, acceptChatRequest, declineChatRequest } = useChatRequests();

    if (chatRequests.length === 0) {
        return (
            <div className="p-4 bg-white rounded-lg shadow">
                <h2 className="text-lg font-semibold mb-4 text-primary border-b pb-2">
                    Chat Requests
                </h2>
                <div className="text-center text-gray-500 py-6">
                    <div className="flex justify-center mb-2">
                        <User className="w-10 h-10 text-gray-300" />
                    </div>
                    <p>No pending chat requests</p>
                </div>
            </div>
        );
    }

    return (
        <div className="p-4 bg-white rounded-lg shadow">
            <h2 className="text-lg font-semibold mb-4 text-primary border-b pb-2">
                Chat Requests ({chatRequests.length})
            </h2>

            <div className="space-y-3">
                {chatRequests.map((request) => {
                    // Calculate time remaining
                    const expiresAt = new Date(request.expiresAt);
                    const timeRemaining = Math.max(
                        0,
                        Math.floor((expiresAt - new Date()) / 1000)
                    );
                    const minutes = Math.floor(timeRemaining / 60);
                    const seconds = timeRemaining % 60;

                    return (
                        <div
                            key={request.chatId}
                            className="border rounded-lg p-3 hover:shadow-md transition"
                        >
                            <div className="flex items-center gap-3 mb-2">
                                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-primary font-bold overflow-hidden">
                                    {request.userPicture && request.userPicture !== "/" ? (
                                        <img
                                            src={request.userPicture}
                                            alt={request.userName}
                                            className="w-full h-full object-cover"
                                        />
                                    ) : (
                                        request.userName?.charAt(0).toUpperCase() || "U"
                                    )}
                                </div>
                                <div className="flex-1">
                                    <h3 className="font-medium">{request.userName || "User"}</h3>
                                    <div className="text-xs text-gray-500 flex items-center">
                                        <Clock className="w-3 h-3 mr-1" />
                                        <span>
                                            Received {formatDistanceToNow(new Date(request.receivedAt), { addSuffix: true })}
                                        </span>
                                    </div>
                                </div>
                                <div className="text-xs bg-orange-100 text-primary px-2 py-1 rounded-full font-medium flex items-center">
                                    <Clock className="w-3 h-3 mr-1" />
                                    {minutes}:{seconds.toString().padStart(2, '0')}
                                </div>
                            </div>

                            <div className="flex justify-between mt-3">
                                <button
                                    onClick={() => declineChatRequest(request.chatId)}
                                    className="flex items-center px-3 py-1 bg-gray-100 text-gray-600 rounded-md hover:bg-gray-200 transition"
                                >
                                    <XCircle className="w-4 h-4 mr-1" />
                                    Decline
                                </button>

                                <button
                                    onClick={() => acceptChatRequest(request.chatId)}
                                    className="flex items-center px-3 py-1 bg-green-100 text-green-600 rounded-md hover:bg-green-200 transition"
                                >
                                    <CheckCircle className="w-4 h-4 mr-1" />
                                    Accept
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}